(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-b2b"] && !Shopify.designMode) return;
  try {
    /* HT et mensualité suivent la variante choisie. */
  document.addEventListener('variant:updated', function (event) {
    var variant = event.detail && event.detail.resource;
    if (!variant || typeof variant.price !== 'number') return;

    var fmt = function (cents) {
      var whole = cents % 100 === 0;
      return new Intl.NumberFormat('fr', { style: 'currency', currency: 'EUR', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(cents / 100);
    };

    document.querySelectorAll('[data-b2b]').forEach(function (root) {
      var den = parseInt(root.dataset.vatDen, 10) || 121;
      var split = parseInt(root.dataset.split, 10) || 3;
      var ht = root.querySelector('[data-b2b-ht]');
      var part = root.querySelector('[data-b2b-part]');
      if (ht) ht.textContent = fmt(Math.round((variant.price * 100) / den));
      if (part) part.textContent = fmt(Math.round(variant.price / split));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-vat-toggle"] && !Shopify.designMode) return;
  try {
    class VatToggle extends HTMLElement {
    #timer = null;
    #controller = null;

    connectedCallback() {
      this.switch = this.querySelector('[data-vat-switch]');
      this.input = this.querySelector('[data-vat-input]');
      this.status = this.querySelector('[data-vat-status]');
      if (!this.switch || !this.input) return;

      this.switch.addEventListener('change', () => this.#onToggle());
      this.input.addEventListener('input', () => this.#schedule());
      this.input.addEventListener('blur', () => this.#flush());
      this.#restore();
    }

    disconnectedCallback() {
      clearTimeout(this.#timer);
      this.#controller?.abort();
    }

    #onToggle() {
      this.switch.setAttribute('aria-expanded', String(this.switch.checked));
      if (this.switch.checked) {
        /* Le champ n'est visible qu'après la transition : on attend un tour. */
        setTimeout(() => this.input.focus({ preventScroll: true }), 200);
        return;
      }
      /* Interrupteur fermé : on efface le numéro du panier, sinon une facture
         partirait avec un numéro que la personne a voulu retirer. */
      this.input.value = '';
      this.#save('');
    }

    #schedule() {
      clearTimeout(this.#timer);
      this.#timer = setTimeout(() => this.#flush(), 600);
    }

    #flush() {
      clearTimeout(this.#timer);
      if (!this.switch.checked) return;
      const value = this.input.value.replace(/\s+/g, '').toUpperCase();
      this.input.value = value;
      this.#save(value);
    }

    async #save(value) {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const attributes = {};
      attributes[this.dataset.attribute] = value;
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
          signal: this.#controller.signal,
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        this.#setStatus(value ? this.dataset.savedLabel : '', 'ok');
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.#setStatus(this.dataset.errorLabel, 'error');
      }
    }

    async #restore() {
      try {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        const value = cart.attributes && cart.attributes[this.dataset.attribute];
        if (!value) return;
        this.input.value = value;
        this.switch.checked = true;
        this.switch.setAttribute('aria-expanded', 'true');
        this.#setStatus(this.dataset.savedLabel, 'ok');
      } catch (error) {
        /* Sans panier lisible, l'interrupteur démarre simplement fermé. */
      }
    }

    #setStatus(text, state) {
      if (!this.status) return;
      this.status.textContent = text;
      this.status.dataset.state = state;
    }
  }

  if (!customElements.get('vat-toggle')) customElements.define('vat-toggle', VatToggle);
  } catch(e) { console.error(e); }
})();

})();
